export const isInIframe = () => window.self !== window.top;
/**
 * Navigates the current window to `url`. Unlike `openUrl`/`window.open`, a plain
 * location assignment needs no transient user activation, so it is not
 * suppressed by the browser when fired outside a user gesture (e.g. the
 * post-booking countdown redirect). Kept as a named export so it can be stubbed
 * in integration tests, matching the `openUrl` seam (BENG-4196).
 */
export const redirectTo = (url) => {
    window.location.assign(url);
};
export function openUrl({ features, method = 'GET', payload, target = '_self', url, }) {
    if (method === 'GET') {
        // Build query string from payload if available
        const query = payload ? '?' + new URLSearchParams(payload).toString() : '';
        // Open GET request with query string
        const fullUrl = url + query;
        return window.open(fullUrl, target, features);
    }
    // For POST create a temporary form
    const form = document.createElement('form');
    form.method = method;
    form.action = url;
    form.target = target;
    // Append hidden inputs for each payload field
    if (payload) {
        Object.entries(payload).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
        });
    }
    document.body.appendChild(form);
    // Open the new tab explicitly if needed, to maintain a reference
    let popup = null;
    if (target === '_blank') {
        popup = window.open('', '_blank', features);
        if (popup) {
            // Ensure the window has a name so the form can submit into it.
            popup.name = popup.name || 'cb-external-redirect';
            form.target = popup.name;
        }
        else {
            console.warn('Popup was blocked by the browser');
        }
    }
    // Submit the form to trigger the POST redirect
    form.submit();
    document.body.removeChild(form);
    return target === '_blank' ? popup : window;
}
